<template>
    <div class="create-goods">
        <el-breadcrumb separator="/">
            <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
            <el-breadcrumb-item :to="{ path: '/enterprise' }">企业列表</el-breadcrumb-item>
            <el-breadcrumb-item>编辑企业</el-breadcrumb-item>
        </el-breadcrumb>
        <div style="margin-top: 1rem; padding: 1.5rem 1rem; background-color: white">
            <el-form ref="form" :rules="rules" :model="form" label-width="180px">
                <el-form-item label="企业名称" prop="name">
                    <el-col :span="8">
                        <el-input v-model="form.name"></el-input>
                    </el-col>
                </el-form-item>
                <el-form-item label="企业代码" prop="code">
                    <el-col :span="8">
                        <el-input v-model="form.code"></el-input>
                    </el-col>
                </el-form-item>
                <el-form-item label="企业地址" prop="address">
                    <el-col :span="8">
                        <el-input v-model="form.address"></el-input>
                    </el-col>
                </el-form-item>
                <el-form-item label="企业电话" prop="tel">
                    <el-col :span="8">
                        <el-input v-model="form.tel"></el-input>
                    </el-col>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="onSubmit">提交更新</el-button>
                    <el-button @click="$router.back()">取消</el-button>
                </el-form-item>
            </el-form>
        </div>
    </div>
</template>
<script>
    import enterpriseApi from "../../api/enterprise";
    export default {
        data: function () {
            return {
                form: {
                    useableCount: 0,
                    shareState: 1,
                    anymousState: 1
                },
                loading: false,
                rules: {
                    name: [{required: true, message: "请输入设备名称", trigger: "blur"}],
                },
            }
        },
        mounted: function() {
            this.loadDevice();
        },
        methods: {
            onSubmit: function () {
                this.$refs["form"].validate(valid => {
                    if(!valid) return;
                    const loading = this.$loading({
                        lock: true,
                        text: '保存中',
                        spinner: 'el-icon-loading',
                    });
                    enterpriseApi.update(this.form).then(result => {
                        loading.close();
                        this.$message({
                            type: 'success',
                            message: '更新成功!'
                        });
                        this.$router.back();
                    })
                })

            },
            loadDevice: function () {
                enterpriseApi.findById(this.$route.query.id).then(data => {
                    this.form = data;
                })
            }
        }
    }
</script>
<style lang="less">
    .standards {
        .add-standard {
            color: #1c6ca1;
            cursor: pointer;
        }
    }
</style>
